import Vue from 'vue';
import VueRouter from 'vue-router';
import User from '@/models/User';
import Workspace from '@/components/protected/Workspace.vue';
import Dashboard from '@/components/protected/dashboard/Dashboard.vue';
import FarmLayout from '@/components/protected/farm/FarmLayout.vue';
import CropPlanner from '@/components/protected/farm/CropPlanner.vue';
import Inputs from '@/components/protected/farm/inputs/Inputs.vue';
import ProfitLoss from '@/components/protected/farm/ProfitLoss.vue';
import FieldLayout from '@/components/protected/farm/fields/FieldLayout.vue';
import FieldList from '@/components/protected/farm/fields/FieldList.vue';
import NewField from '@/components/protected/farm/fields/NewField.vue';
import AssignedAudits from '@/components/protected/audits/AssignedAudits.vue';
import MyAuditList from '@/components/protected/audits/MyAuditList.vue';
import AuditRequest from '@/components/protected/audits/AuditRequest.vue';
import TemplateConsoleLayout from '@/components/protected/audits/templateConsole/TemplateConsoleLayout.vue';
import AddTemplate from '@/components/protected/audits/templateConsole/AddTemplate.vue';
import ProfileLayout from '@/components/protected/audits/profile/ProfileLayout.vue';
import UserProfile from '@/components/protected/audits/profile/UserProfile.vue';
import ClusterLayout from '@/components/protected/audits/clusters/ClusterLayout.vue';
import Clusters from '@/components/protected/audits/clusters/Clusters.vue';
import AddCluster from '@/components/protected/audits/clusters/AddCluster.vue';
import AcceptReject from '@/components/protected/audits/action/AcceptReject.vue';
import ViewAudit from '@/components/protected/audits/template/ViewAudit.vue';
import ViewLandTitle from '@/components/protected/land_titles/ViewLandTitle.vue';
import AddressBookLayout from '@/components/protected/org/addressBooks/AddressBookLayout.vue';
import AddressBookEntries from '@/components/protected/org/addressBooks/AddressBookEntries.vue';
import NewAddressBookEntry from '@/components/protected/org/addressBooks/NewAddressBookEntry.vue';
import AddressBookActionLayout from './components/protected/org/addressBooks/action/AddressBookActionLayout.vue';
import AddressBookEdit from './components/protected/org/addressBooks/action/AddressBookEdit.vue';
import Groups from '@/components/protected/org/Groups.vue';
import Wallets from '@/components/protected/org/Wallets.vue';
import Proposals from './components/protected/proposals/Proposals.vue';
import ViewProposal from './components/protected/proposals/proposal/ViewProposal.vue';
import MyAccountLayout from '@/components/protected/myaccount/MyAccountLayout.vue';
import ViewProfile from '@/components/protected/myaccount/ViewProfile.vue';
import EditProfile from '@/components/protected/myaccount/EditProfile.vue';
import MyWallet from '@/components/protected/myaccount/MyWallet.vue';
import LandTitleLayout from '@/components/protected/land_titles/LandTitleLayout.vue';
import Register from '@/components/protected/land_titles/Register.vue';
import Search from '@/components/protected/land_titles/Search.vue';
import AuthLayout from '@/components/auth/login/AuthLayout.vue';
import Login from '@/components/auth/login/Login.vue';
import Signup from '@/components/auth/login/Signup.vue';
import ResetPwd from '@/components/auth/ResetPwd.vue';
import ChangePassword from '@/components/auth/ChangePassword.vue';
import Referral from '@/components/auth/registration/Referral.vue';
import RegistrationLayout from '@/components/auth/registration/RegistrationLayout.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Workspace,
      children: [
        {
          path: '',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'farm',
          component: FarmLayout,
          children: [
            {
              path: 'planner',
              name: 'cropplanner',
              component: CropPlanner
            },
            {
              path: 'inputs',
              name: 'inputs',
              component: Inputs
            },
            {
              path: 'pl',
              name: 'pl',
              component: ProfitLoss
            },
            {
              path: 'fields',
              component: FieldLayout,
              children: [
                {
                  path: '',
                  name: 'fields',
                  component: FieldList
                },
                {
                  path: 'new',
                  name: 'newfield',
                  component: NewField
                }
              ]
            }
          ]
        },

        {
          path: 'assignedaudits',
          name: 'assignedaudits',
          component: AssignedAudits
        },
        {
          path: 'my',
          name: 'myaudits',
          component: MyAuditList
        },
        {
          path: 'new',
          name: 'newaudit',
          component: AuditRequest
        },
        {
          path: 'template',
          component: TemplateConsoleLayout,
          children: [
            {
              path: 'new',
              name: 'new-template',
              component: AddTemplate
            }
          ]
        },
        {
          path: 'profile',
          component: ProfileLayout,
          children: [
            // {
            //     path: "org/:orgid",
            //     props: true,
            //     name: "orgprofile",
            //     component: OrgProfile
            // },
            {
              path: 'profile/:userId',
              props: true,
              name: 'userprofile',
              component: UserProfile
            }
          ]
        },
        {
          path: 'clusters',
          component: ClusterLayout,
          children: [
            {
              path: '',
              name: 'clusters',
              component: Clusters
            },
            {
              path: 'new',
              name: 'newcluster',
              component: AddCluster
            }

          ]
        },
        {
          path: '/audits/:auditId/view',
          props: true,
          name: 'viewaudit',
          component: ViewAudit
        },
        {
          path: '/audits/:auditId/accept',
          props: true,
          name: 'acceptaudit',
          component: AcceptReject
        },
        {
          path: '/audits/:auditId/land_title/:titleid',
          name: 'viewtitle',
          props: true,
          component: ViewLandTitle
        },

        // {
        //     path: 'org',
        //     component: OrgLayout,
        //     children: [
        //         // {
        //         //     path: "profile",
        //         //     name: "orgsprofile",
        //         //     component: ViewProfile
        //         // },
        //         // {
        //         //     path: "members",
        //         //     name: "orgmembers",
        //         //     component: Members
        //         // },
        //         // {
        //         //     path: "subscription",
        //         //     name: "orgsubscription",
        //         //     component: Subscription
        //         // },
        //         {

        //             path: "integrations",
        //             name: "integrations",
        //             component: Integrations
        //         },
        //         // {
        //         //     path: "wallet",
        //         //     name: "orgwallet",
        //         //     component: OrgWallet
        //         // },
        //         {
        //             path: "invoice",
        //             name: "invoices",
        //             component: Invoices
        //         },
        //         {
        //             path: "management",
        //             name: "management",
        //             component: MembershipManagement
        //         },
        //         {
        //             path: "viewplan/:planid",
        //             name: "viewplan",
        //             props: true,
        //             component: ViewMembershipPlan
        //         },

        //     ]
        // },
        {
          path: 'addressbook',
          component: AddressBookLayout,
          children: [
            {
              path: '',
              name: 'address-book-entries',
              component: AddressBookEntries
            },
            {
              path: 'new',
              name: 'new-address-book-entry',
              component: NewAddressBookEntry
            },
            {
              path: ':addressbookid',
              component: AddressBookActionLayout,
              children: [
                {
                  path: '',
                  props: true,
                  name: 'address-book-edit',
                  component: AddressBookEdit
                }
              ]
            }
          ]

        },
        {
          path: 'groups',
          name: 'groups',
          props: true,
          component: Groups
        },
        {
          path: 'wallets',
          name: 'wallets',
          props: true,
          component: Wallets
        },
        {
          path: '/proposals',
          name: 'proposals',
          component: Proposals
        },
        {
          path: '/proposals/:proposalId',
          props: true,
          name: 'view-proposal',
          component: ViewProposal
        },

        {
          path: 'myaccount',
          component: MyAccountLayout,
          children: [
            {
              path: '',
              name: 'viewprofile',
              component: ViewProfile
            },
            {
              path: 'editprofile',
              name: 'editprofile',
              component: EditProfile
            },
            {
              path: 'wallet',
              name: 'mywallet',
              component: MyWallet
            }
          ]
        },
        {
          path: 'land-title',
          component: LandTitleLayout,
          children: [
            {
              path: 'register',
              name: 'land_title_register',
              component: Register
            },
            {
              path: 'search',
              name: 'search_land_titles',
              component: Search
            }
          ]
        }
      ]
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          path: 'login',
          name: 'login',
          meta: {
            unsecured: true
          },
          component: Login
        },
        {
          path: 'signup',
          name: 'signup',
          props: true,
          meta: {
            unsecured: true
          },
          component: Signup
        },
        {
          path: 'resetpwd',
          name: 'resetpwd',
          meta: {
            unsecured: true
          },
          component: ResetPwd
        },

        {
          path: 'changepassword/:token?',
          name: 'changepassword',
          meta: {
            unsecured: true
          },
          props: true,
          component: ChangePassword
        }
      ]
    },
    {
      path: '/referral/:referral_id',
      props: true,
      meta: {
        unsecured: true
      },
      component: Referral
    },
    {
      path: '/register',
      name: 'register',
      props: true,
      meta: {
        unsecured: true
      },
      component: RegistrationLayout
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.meta.unsecured) {
    const user = User.from(localStorage.token);
    if (user) {
      next();
    } else {
      next({
        name: 'login'
      });
    }
  } else {
    next();
  }
});

export default router;
